const PROVIDER_KEY = 'hemmah_oauth_provider';
const SUPPORTED_PROVIDERS = new Set(['google', 'github']);

export function rememberOAuthProvider(provider) {
  const normalized = String(provider || '').toLowerCase();
  if (!SUPPORTED_PROVIDERS.has(normalized)) return;

  try {
    window.sessionStorage.setItem(PROVIDER_KEY, normalized);
  } catch {}
}

export function clearOAuthProvider() {
  try {
    window.sessionStorage.removeItem(PROVIDER_KEY);
  } catch {}
}

export function getPendingOAuthCallback(authBase) {
  if (typeof window === 'undefined' || window.location.pathname !== '/') {
    return '';
  }

  const params = new URLSearchParams(window.location.search);
  if (!params.get('code') || !params.get('state')) return '';

  const issuer = params.get('iss');
  let provider = issuer === 'https://accounts.google.com' ? 'google' : '';

  if (!provider) {
    try {
      provider = window.sessionStorage.getItem(PROVIDER_KEY) || '';
    } catch {}
  }

  if (!SUPPORTED_PROVIDERS.has(provider)) return '';

  const configuredBase = String(authBase || '/auth').replace(/\/$/, '');
  const base = configuredBase === '/auth'
    ? '/.netlify/functions/auth'
    : configuredBase;
  return `${base}/${provider}/callback?${params.toString()}`;
}
